import { defineQuery } from "@rocicorp/zero";
import { z } from "zod";
import type {} from "../zero-context";
import { zql } from "../schema";
import { workspaceFullMemberGuard } from "./access-filters";

export const coworkersQueries = {
  byWorkspace: defineQuery(z.string(), ({ args: workspaceId, ctx: { sub } }) =>
    zql.coworkers
      .where("workspace_id", workspaceId)
      .where("enabled", true)
      .whereExists("workspace", workspaceFullMemberGuard(sub))
      .related("user"),
  ),
  allByWorkspace: defineQuery(
    z.string(),
    ({ args: workspaceId, ctx: { sub } }) =>
      zql.coworkers
        .where("workspace_id", workspaceId)
        .whereExists("workspace", workspaceFullMemberGuard(sub))
        .related("user"),
  ),
  byId: defineQuery(z.string(), ({ args: id, ctx: { sub } }) =>
    zql.coworkers
      .where("id", id)
      .whereExists("workspace", workspaceFullMemberGuard(sub))
      .related("user")
      .related("creator")
      .one(),
  ),
};
